/**
 * 逻辑流编辑器 - 顶部工具栏
 */

import React from 'react';
import {Button, Space, Tag, Tooltip} from 'antd';
import {
    ApartmentOutlined,
    CheckCircleOutlined,
    CodeOutlined,
    HistoryOutlined,
    PlusOutlined,
    SaveOutlined,
    SplitCellsOutlined,
} from '@ant-design/icons';
import type {EditorViewMode} from '../../../store/logicFlowStore';

interface Props {
    isDirty: boolean;
    isSaving: boolean;
    strategyId: number | null;
    strategyName: string;
    viewMode: EditorViewMode;
    onSave: () => void;
    onValidate: () => void;
    onNew: () => void;
    onOpenHistory: () => void;
    onAutoLayout: () => void;
    onViewModeChange: (mode: EditorViewMode) => void;
}

const LogicFlowToolbar: React.FC<Props> = ({
                                               isDirty,
                                               isSaving,
                                               strategyId,
                                               strategyName,
                                               viewMode,
                                               onSave,
                                               onValidate,
                                               onNew,
                                               onOpenHistory,
                                               onAutoLayout,
                                               onViewModeChange,
                                           }) => {
    return (
        <div style={toolbarStyle}>
            <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                <span style={titleStyle}>{strategyName || '逻辑流策略编辑器'}</span>
                {isDirty ? (
                    <Tag color="gold" style={{fontSize: '11px'}}>未保存</Tag>
                ) : strategyId != null ? (
                    <Tag color="green" style={{fontSize: '11px'}}>已保存 #{strategyId}</Tag>
                ) : null}
            </div>

            <Space size="small">
                <Tooltip title="新建">
                    <Button size="small" icon={<PlusOutlined/>} onClick={onNew}/>
                </Tooltip>
                <Tooltip title="我的策略">
                    <Button size="small" icon={<HistoryOutlined/>} onClick={onOpenHistory}/>
                </Tooltip>

                <div style={{width: '1px', height: '20px', background: 'var(--pt-border)', margin: '0 4px'}}/>

                <Tooltip title="自动布局">
                    <Button size="small" icon={<ApartmentOutlined/>} onClick={onAutoLayout}/>
                </Tooltip>

                <Tooltip title={'flow' === viewMode ? '查看代码' : '查看画布'}>
                    <Button
                        size="small"
                        icon={'flow' === viewMode ? <SplitCellsOutlined/> : <CodeOutlined/>}
                        onClick={() => onViewModeChange('flow' === viewMode ? 'code' : 'flow')}
                    />
                </Tooltip>

                <Tooltip title="校验模型">
                    <Button size="small" icon={<CheckCircleOutlined/>} onClick={onValidate}/>
                </Tooltip>

                <Tooltip title="保存策略">
                    <Button
                        type="primary"
                        size="small"
                        icon={<SaveOutlined/>}
                        loading={isSaving}
                        onClick={onSave}
                        disabled={!isDirty}
                    />
                </Tooltip>
            </Space>
        </div>
    );
};

const toolbarStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 16px',
    borderBottom: '1px solid rgba(255,255,255,0.08)',
    background: 'rgba(12,17,32,0.95)',
    backdropFilter: 'blur(12px)',
    minHeight: '48px',
};

const titleStyle: React.CSSProperties = {
    fontSize: '16px',
    fontWeight: 700,
    color: '#F0B429',
    fontFamily: "'Syne', sans-serif",
};

export default LogicFlowToolbar;
